export enum CardTypes {
  signUp = 'signUp',
  logIn = 'logIn',
}
